export default __webpack_public_path__ + "static/media/illustration_brain.d9c0917c.png";